export const PORTAL_PROFILE_MENU_W = 240;

/** Fixed-position style for account menus anchored to a bottom-rail avatar/button. */
export function getPortalProfileMenuStyle(
  anchorEl,
  { mobileMq = "(max-width: 1024px)", menuWidth = PORTAL_PROFILE_MENU_W } = {}
) {
  if (!anchorEl) return null;
  const rect = anchorEl.getBoundingClientRect();
  const isMobile = window.matchMedia(mobileMq).matches;

  if (isMobile) {
    return {
      position: "fixed",
      top: rect.bottom + 8,
      right: Math.max(12, window.innerWidth - rect.right),
      left: "auto",
      bottom: "auto",
      width: Math.min(menuWidth, window.innerWidth - 24),
    };
  }

  return {
    position: "fixed",
    left: rect.right + 10,
    bottom: window.innerHeight - rect.bottom,
    top: "auto",
    right: "auto",
    width: menuWidth,
  };
}
